module.exports = __webpack_public_path__ + "static/media/allocations.55f8034e.svg";